import IconVisible from "../../components/icons/IconVisible";

// A single show/hide-able row in the "add answer connector" form. Replaces
// six near-identical copy-pasted blocks that used to live in QestionPlate.jsx.
export default function ConnectorFormField({ fieldKey, visible, editing, label, onToggleVisibility, children }) {
    if (!visible) return null;

    return (
        <div className="connector-from-field">
            {editing ? (
                <div className="connector-from-field-entity" onClick={() => onToggleVisibility(fieldKey)}>
                    <IconVisible fillColor="icon-teel" style={{ height: 20, width: 20 }} />
                    <p>{label}</p>
                </div>
            ) : (
                ""
            )}
            {children}
        </div>
    );
}
